export default __webpack_public_path__ + "736e7c09ac438a1331493259a68401e3.svg";